import React from 'react';
import { Link } from "react-router-dom";
import '../../Home.css';
import '../../Details.css';
import './ENGELEC.css';

function ENGELEC() {
   return (
    <div className = "grid-container">
      <div className="grid-item back">
        <Link to="/Home" className="purple back">Back</Link>
      </div>

      <div className="grid-item exit">
          <a className="purple exit" href = "https://www.sfu.ca/mechatronics.html" target = "_blank" rel="noopener noreferrer">Exit</a>
      </div>

      <div className = "grid-item r1 c1">
        <Link to="/MSE420" className="dark-orange">MSE 420</Link>
      </div>
      <div className = "grid-item r1 c2">
        <Link to="/MSE421" className="dark-orange">MSE 421</Link>
      </div>
      <div className = "grid-item r1 c3">
        <Link to="/MSE422" className="dark-orange">MSE 422</Link>
      </div>
      <div className = "grid-item r1 c4">
        <Link to="/MSE423" className="dark-orange">MSE 423</Link>
      </div>
      <div className = "grid-item r1 c5">
        <Link to="/MSE424" className="dark-orange">MSE 424</Link>
      </div>

      <div className = "grid-item r2 c1">
        <Link to="/MSE425" className="dark-orange">MSE 425</Link>
      </div>
      <div className = "grid-item r2 c2">
        <Link to="/MSE426" className="dark-orange">MSE 426</Link>
      </div>
      <div className = "grid-item r2 c3">
        <Link to="/MSE427" className="dark-orange">MSE 427</Link>
      </div>
      <div className = "grid-item r2 c4">
        <Link to="/MSE428" className="dark-orange">MSE 428</Link>
      </div>
      <div className = "grid-item r2 c5">
        <Link to="/MSE429" className="dark-orange">MSE 429</Link>
      </div>

      <div className = "grid-item r3 c1">
        <Link to="/MSE450" className="green">MSE 450</Link>
      </div>
      <div className = "grid-item r3 c2">
        <Link to="/MSE451" className="green">MSE 451</Link>
      </div>
      <div className = "grid-item r3 c3">
        <Link to="/MSE452" className="green">MSE 452</Link>
      </div>
      <div className = "grid-item r3 c4">
        <Link to="/MSE480" className="blue">MSE 480</Link>
      </div>
      <div className = "grid-item r3 c5">
        <Link to="/MSE481" className="blue">MSE 481</Link>
      </div>

      <div className = "grid-item r4 c1">
        <Link to="/MSE483" className="blue">MSE 483</Link>
      </div>
      <div className = "grid-item r4 c2">
        <Link to="/MSE490" className="grey">MSE 490*</Link>
      </div>
      <div className = "grid-item r4 c3">
        <Link to="/MSE491" className="grey">MSE 491*</Link>
      </div>
      <div className = "grid-item r4 c4">
        <Link to="/MSE492" className="grey">MSE 492*</Link>
      </div>
      
      <div className = "note">
        <h2>*Special Topics</h2>
      </div>
    </div>
  );
}

export default ENGELEC;
